import { Button } from 'antd'
import styled, { css } from 'styled-components'

const StyledDrawerButton = styled(Button)`
  margin-left: 0px;

  ${props =>
    props.isActive &&
    css`
      border-color: #096dd9;
      background-color: #fff;
      color: #096dd9:
    `};
`

export default StyledDrawerButton
